import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a0d3142"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"position":"absolute"},
  class: "d-none d-md-block"
}, null, -1))
const _hoisted_2 = { class: "form-floating doPrawej" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "fastestReturn",
  selected: ""
}, "od najszybszego zwrotu", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "chippest" }, "od najtańszych", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "expensive" }, "od najdroższych", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "mostProfit" }, "od największego zarobku", -1))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingSelect" }, "Posortuj urządzenia", -1))
const _hoisted_9 = { class: "form-floating doPrawej" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: false,
  selected: ""
}, "wszystkie", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "tylko rentowne", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingSelect2" }, "Wyświetl:", -1))
const _hoisted_14 = { class: "form-floating doPrawej" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "lista", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: false,
  selected: ""
}, "kafelki", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingSelect3" }, "Wyświetl:", -1))
const _hoisted_19 = {
  class: "d-none d-md-block",
  style: {"position":"absolute"}
}
const _hoisted_20 = { class: "m-2" }

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'tabelaKoparek_filtry',
  props: {
  counter: { type: Number, default: 0 },
},
  setup(__props) {

const props = __props;


const store = useStore();

const profitable = computed<number>({
  get: () => store.getters["miners/getProfitable"],
  set: (value: number) => {
    store.commit("miners/setProfitable", value);
  },
});
const advancedFilters = computed<number>({
  set: (value: number) => {
    store.commit("miners/setAdvancedFilter", value);
  },
  get: () => store.getters["miners/getAdvancedFilter"],
});
const list = computed<number>({
  set: (value: number) => {
    store.commit("miners/setList", value);
  },
  get: () => store.getters["miners/getList"],
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((advancedFilters).value = $event)),
        class: "form-select",
        id: "floatingSelect"
      }, _hoisted_7, 512), [
        [_vModelSelect, advancedFilters.value]
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profitable).value = $event)),
        class: "form-select",
        id: "floatingSelect2"
      }, _hoisted_12, 512), [
        [
          _vModelSelect,
          profitable.value,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((list).value = $event)),
        class: "form-select",
        id: "floatingSelect3"
      }, _hoisted_17, 512), [
        [
          _vModelSelect,
          list.value,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_18
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("p", _hoisted_20, "Wyświetlanie " + _toDisplayString(__props.counter) + " koparek.", 1)
    ])
  ]))
}
}

})